import { Transform } from 'class-transformer';

export function TransformFloat({ toClassOnly = true } = {}) {
	return Transform(
		({ value }) => {
			if (value === null || value === '' || isNaN(Number(value))) {
				return null;
			}
			return parseFloat(value);
		},
		{ toClassOnly },
	);
}
